import { Link } from 'react-router-dom'
import { EstadoVazio } from '../components/Estados'

/**
 * Endereço que não existe.
 *
 * Acontece quando um link antigo do sistema anterior é colado aqui. Dizer isso e oferecer uma
 * saída é mais útil do que um "404" sozinho, que faz o usuário achar que o sistema caiu.
 *
 * Fica fora da moldura de propósito: sem sessão não há menu para desenhar, e o endereço errado
 * pode muito bem ter sido digitado por quem nunca entrou. As telas que ainda não existem NÃO caem
 * aqui — elas têm rota própria e página própria, que diz o que vai ter e onde fazer hoje.
 *
 * @returns a tela de endereço inexistente
 */
export function PaginaNaoEncontrada() {
  return (
    <main className="mx-auto max-w-2xl px-6 py-16">
      <EstadoVazio
        titulo="Este endereço não existe"
        ajuda="A página pode ter sido movida, ou o link veio do sistema anterior. O painel mostra o que está esperando você."
        acao={
          <div className="flex flex-wrap justify-center gap-2">
            <Link
              to="/painel"
              className="rounded-lg bg-niteroi-700 px-3.5 py-2 text-sm font-medium text-white hover:bg-niteroi-800"
            >
              Ir para o painel
            </Link>
            <Link
              to="/gmuds"
              className="rounded-lg border border-slate-300 bg-white px-3.5 py-2 text-sm font-medium text-slate-800 hover:bg-slate-50"
            >
              Ver as solicitações
            </Link>
          </div>
        }
      />
    </main>
  )
}
